(function() {
  'use strict';

  window.ngModule.component('nepOfflineNotification', {
    template: require('./offline.view.html'),
  });
})();
